import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import SVG from 'react-inlinesvg';
import wellDoneIcon from '@/assets/svg/well-done-80x80.svg';
import close from '@/assets/svg/close.svg';
import classNames from './LevelCompleteNotice.module.scss';

interface LevelCompleteNoticeProps {
  className?: string;
  emitOnQuit: (() => void) | undefined;
}

/**
 * Shown instead of FinishLevel when the student finishes the last unit of their
 * assigned level AND their group's GroupSettings.allowIndividualAdvancement is false,
 * i.e. automatic progression to the next level is restricted by class configuration.
 *
 * Reuses the app's existing "Well Done" confetti design (see FinishLevel/WelcomeConfetti)
 * so it's visually consistent, but stays up until the student dismisses it via the close
 * button instead of auto-advancing/reloading.
 */
const LevelCompleteNotice = ({ className, emitOnQuit }: LevelCompleteNoticeProps) => {
  const { t } = useTranslation();

  return (
    <div className={classes('welcomeConfetti', 'fadeIn', className)}>
      <button
        type='button'
        className={classNames.close}
        onClick={() => emitOnQuit?.()}
        aria-label={t('close').toString()}
      >
        <SVG src={close} />
      </button>
      <SVG className={classNames.icon} src={wellDoneIcon} />
      <div className={classNames.title}>{`${t('wellDone')}!`}</div>
      <div className={classNames.description}>{t('myProgressCompletedNotice')}</div>
    </div>
  );
};

export default LevelCompleteNotice;
